import { AlkLogger } from '@alk/core';
import { ARRAY_OF_RESOLVED_TENOR_01 } from '../../../mocks/tenors.data';
import { delay, startWith } from 'rxjs/operators';
import { injectable } from 'inversify';
import { IResolvedTenor, ISessionDisposable, ITenorRequest } from '../../../interfaces';
import { ITenorResolveAdapterService } from './tenor-resolve-adapter.interface';
import { never, Observable } from 'rxjs';

const MAX_RESPONSE_DELAY = 600;

@injectable()
export class TenorResolveAdapterMock implements ITenorResolveAdapterService, ISessionDisposable {

    create(tenors: Array<ITenorRequest>): number {
        AlkLogger.debug('[TenorResolveAdapterMock#create]', tenors);

        return 0;
    }

    remove(): void {
        AlkLogger.debug('[TenorResolveAdapterMock#remove]');
    }

    stop(): void {
        AlkLogger.debug('[TenorResolveAdapterMock#stop]');
    }

    resolvedTenorObservable(): Observable<Array<IResolvedTenor>> {
        AlkLogger.debug('[TenorResolveAdapterMock#resolvedTenorObservable]');

        return never()
            .pipe(
                startWith(ARRAY_OF_RESOLVED_TENOR_01),
                delay(MAX_RESPONSE_DELAY * Math.random()),
            );
    }
}
